import { Box, Stack, Typography, useTheme } from "@mui/material";
import { ChevronRight } from "lucide-react";
import type { ElementType, FC } from "react";

export type SettingsMenuItemType = {
	icon: ElementType;
	label: string;
	iconBg: string;
	iconColor: string;
	onClick?: () => void;
};

type Props = {
	item: SettingsMenuItemType;
	showDivider: boolean;
};

export const SettingsMenuItem: FC<Props> = ({ item, showDivider }) => {
	const theme = useTheme();
	const Icon = item.icon;

	return (
		<Stack
			direction="row"
			alignItems="center"
			gap={1.6}
			px={1.6}
			py={1.2}
			onClick={item.onClick}
			sx={{
				cursor: item.onClick ? "pointer" : "default",
				"&:active": item.onClick
					? { bgcolor: theme.palette.grey[50] }
					: undefined,
				borderBottom: showDivider
					? `1px solid ${theme.palette.grey[100]}`
					: undefined,
			}}
		>
			<Box
				sx={{
					width: 40,
					height: 40,
					borderRadius: "50%",
					bgcolor: item.iconBg,
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					flexShrink: 0,
				}}
			>
				<Icon size={20} color={item.iconColor} />
			</Box>
			<Typography
				fontSize={16}
				fontWeight={400}
				color={theme.palette.grey[900]}
				flex={1}
			>
				{item.label}
			</Typography>
			{item.onClick && (
				<ChevronRight size={20} color={theme.palette.grey[400]} />
			)}
		</Stack>
	);
};
